import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';


@Component({
    selector: 'notification-preview',
    templateUrl: './notification-preview.component.html',
    standalone: true,
    imports: [AfTranslateDirective]
})
export class NotificationPreviewComponent implements OnInit {
  notificationPreview:any = {
    html: null
  }
  constructor(private apiService: ApiServiceService,
    private sanitizer: DomSanitizer,
    private dialogRef: DynamicDialogRef<NotificationPreviewComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  ngOnInit(): void {
    if(this.dialogConfig.data.type === 'public-alert-process'){
      this.getNotificationInfo();
    }else{
      this.notificationPreview.html = this.sanitizer.bypassSecurityTrustHtml(this.dialogConfig.data.html);
    }
  }

  getNotificationInfo(){
    this.apiService.get('notifications/public-alert-process/notification', this.dialogConfig.data.notification.alertNotificationId)
    .then((data:any)=>{
      this.notificationPreview.html = this.sanitizer.bypassSecurityTrustHtml(data.customBody);
    }, ()=>{})
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }
}
